/* eslint-disable */
import React, { useState, useContext, useEffect, useCallback } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  TextField,
  Button,
  CardContent,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "@material-ui/icons";
// Internal components
import { ThreeDots } from "react-loader-spinner";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import AuthContext from "../../contexts/AuthProvider";
import { getAltLabel } from "utils/getAltLabel";
import OnePage from "views/InitiativesProgram/OnePage_v2.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import {
  ArrowForward,
  Edit,
  ArrowBack,
  ExpandLess,
  ExpandMore,
  Search,
  RadioButtonUnchecked,
} from "@material-ui/icons"; // Import the desired icon

import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import Card from "components/Card/Card.js";
import styles from "../../assets/jss/material-dashboard-pro-react/views/initiativesManagementStyle.js";
import EditSectionModal from "../../components/EditSectionModal/EditSectionModal.js";
import SaveIcon from "@material-ui/icons/Save";

import {
  cardTitle,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faFile,
  faComment,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "moment/locale/pt-br"; // If you wish PT-BR Formatting

import insightsLogo from "../../assets/img/insights_logo.PNG";
import { client } from "../../services/axiosClient.js";
import { darkenColor, lightenByPercentage } from "utils/colorUtils";
import { addHeaderLogo } from "utils/pdfGenerator.js";

// -------------------Helper Functions ------------------------------------------------------------------------------------------------------------------------------------------

// Filters the latest date between [Start_date, End_Date] from the section

const statusToColor = (status) => {
  switch (status) {
    case "red":
      return "#E04F5F";
    case "yellow":
      return "#ffbb00";
    case "green":
      return "#4caf50";
    default:
      return "#9e9e9e";
  }
};

const statusRanking = {
  red: 1,
  yellow: 2,
  green: 3,
  gray: 4,
  null: 4,
};

const aggregateStatus = (statuses) => {
  if (statuses.includes("red")) return "red";
  if (statuses.includes("yellow")) return "yellow";
  return "green";
};

// ---------------------------------------------------------

export default function ProgramMeetingManagement() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const { t } = useTranslation();

  // ------------------------------------------------------

  const ProgramMeetingStyles = (theme, clientColorArg) => ({
    ...styles(theme, clientColorArg), // Certifique-se que styles() usa clientColorArg
    ...customSelectStyle(theme, clientColorArg),
    ...customInputStyle(clientColorArg),

    container: {
      marginTop: "-50px",
      padding: theme.spacing(1),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(2),
      },
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "0px",
      marginBottom: "0px",
      padding: "10px",
    },
    iconButtonCustom: {
      cursor: "pointer",
      "&:hover": {
        color: clientColorArg,
      },
    },
    headerBar: {
      backgroundColor: "#fff",
      boxShadow: "none",
      borderBottom: "1px solid #ddd",
      marginBottom: theme.spacing(2),
    },
    headerTitle: {
      flexGrow: 1,
      fontWeight: 500,
      color: "#333",
    },
    filterCard: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1.5),
    },
    sectionSelect: {
      marginRight: theme.spacing(2),
      minWidth: 200,
    },
    onePageDateSelect: {
      minWidth: 200,
    },
    cardContentWrapper: {
      padding: theme.spacing(2),
    },
    sidebarWrapper: {
      borderLeft: `6px solid ${clientColorArg}`, // Use clientColorArg
      height: "100%",
      borderRadius: "3px 3px 3px 3px",
      [theme.breakpoints.up("md")]: {
        maxHeight: "80vh",
      },
    },
    sidebarTitle: {
      padding: theme.spacing(1),
      fontWeight: 500,
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid #ddd",
    },
    nestedItem: {
      paddingLeft: theme.spacing(2),
    },
    initiativeItem: {
      padding: theme.spacing(1),
      cursor: "pointer",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",

      "&:hover": {
        backgroundColor: `${clientColorArg}1A`,
      },
      marginBottom: theme.spacing(1),
    },
    activeInitiative: {
      backgroundColor: `${clientColorArg}2A`,
    },
    statusCircle: {
      display: "inline-block",
      width: 25,
      height: 25,
      borderRadius: "50%",
      flexShrink: 0,
    },
    contentArea: {
      [theme.breakpoints.up("md")]: {
        maxHeight: "80vh",
        overflowY: "auto",
      },
    },
    reviewCheckbox: {
      marginTop: theme.spacing(1),
    },
    commentsCard: {
      marginTop: theme.spacing(2),
    },
    formField: {
      marginBottom: theme.spacing(2),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    sectionList: {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "80vh",
      overflowY: "auto",
      borderRadius: "10px",
    },
    sectionListItem: {
      padding: theme.spacing(1),
      borderBottom: `1px solid ${clientColorArg}`,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: `${clientColorArg}2A`,
      },
    },
    floatingCard: {
      position: "fixed",
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1200,
      backgroundColor: "#fff",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      borderRadius: "0 0 8px 8px",
      padding: "6px 4px 4px 10px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      maxWidth: "90%",
      [theme.breakpoints.down("sm")]: {
        position: "static",
        alignItems: "center",
        maxWidth: "100%",
        transform: "none",
        zIndex: 1200,
        borderRadius: 0,
        margin: "-40px 15px 37px 0",
        backgroundColor: "#EEEE",
        borderBottom: "1px solid " + grayColor[4],
        boxShadow: "none",
      },
    },
    floatingCardTitle: {
      fontSize: "14px",
      color: "#333",
      marginRight: "10px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    cardButton: {
      padding: "0 !important",
      margin: "15px 15px 0 10px !important",
      height: "24px !important",
      width: "32px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      backgroundColor: clientColorArg + " !important",
      "&.MuiButton-root": {
        cursor: "pointer",
      },
    },
    cardButtonCancel: {
      padding: "0 !important",
      margin: "15px 15px 0 10px !important",
      height: "24px !important",
      width: "32px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      backgroundColor: "#ff9800 !important",
      "&.MuiButton-root": {
        cursor: "pointer",
      },
    },
    cardButtonIcon: {
      margin: "0 !important",
      position: "absolute !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%)",
      width: "18px !important",
      height: "18px !important",
      color: "#FFFFFF",
    },
    branchTitle: {
      fontSize: "15px",
      fontWeight: 600,
      color: "#333",
      marginBottom: theme.spacing(1),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      cursor: "pointer",
      gap: theme.spacing(1),
    },
    workfrontTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#555",
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      cursor: "pointer",
      gap: theme.spacing(1),
    },
    initiativeTitle: {
      fontSize: "13px",
      fontWeight: 400,
      color: "#666",
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(4),
      display: "flex",
      alignItems: "center",
      borderRadius: 4,
      cursor: "pointer",
      transition: "background-color 0.2s",
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    },
    loadingSpinner: {
      // <= ADICIONADO PARA LOADING
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      padding: theme.spacing(2),
    },
  });

  const client_styles = (theme) => ({
    ...ProgramMeetingStyles(theme, clientColor),
  });

  const useStyles = makeStyles(client_styles);

  const classes = useStyles();

  // States for initiatives and selection

  // States for data from backend
  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedSection, setSelectedSection] = useState(null);

  const [groupedInitiatives, setGroupedInitiatives] = useState({});
  const [allBranchesSorted, setAllBranchesSorted] = useState([]);
  const [workfrontsSortedByBranch, setWorkfrontsSortedByBranch] = useState({});

  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const [currentOnePageData, setCurrentOnePageData] = useState(null);
  const [availableOnePageDates, setAvailableOnePageDates] = useState([]);
  const [selectedOnePageDate, setSelectedOnePageDate] = useState("");

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  // Loading states
  const [loadingSections, setLoadingSections] = useState(false);
  const [loadingSidebarData, setLoadingSidebarData] = useState(false);
  const [loadingOnePage, setLoadingOnePage] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [savingComment, setSavingComment] = useState(false);
  const [togglingReview, setTogglingReview] = useState(false);

  const isInitialLoading = loadingSections || loadingSidebarData; // Combina os loadings

  // States for Modal Opening
  const [isModalOpen, setIsModalOpen] = useState(false);

  // States for UI
  const [expandedBranches, setExpandedBranches] = useState([]);
  const [expandedWorkfronts, setExpandedWorkfronts] = useState({});
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isCommentsDrawerOpen, setIsCommentsDrawerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [isPageReady, setIsPageReady] = useState(false);

  const [pdfComments, setPdfComments] = useState([]);
  const [loadingPdfData, setLoadingPdfData] = useState(false);

  const onePageHasApprovalConfig = userDetails?.onePageHasApproval || {
    has_approval: "no",
  };

  // Function to render floating card

  const renderFloatingCard = () => {
    if (!selectedSection) return null;

    return (
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {selectedSection.section_name}
          {selectedInitiative && (
            <span style={{ marginLeft: 10, fontSize: "14px", color: "#666" }}>
              | {selectedInitiative.name}
            </span>
          )}
        </div>
        <Tooltip title={t("program_meeting.actions.edit_section")}>
          <Edit
            className={classes.iconButtonCustom}
            onClick={handleOpenModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </Tooltip>
        <Tooltip title={t("program_meeting.actions.generate_pdf")}>
          <span>
            {" "}
            {/* Span para Tooltip funcionar com botão desabilitado */}
            <Button
              onClick={handleGeneratePdf}
              disabled={loadingPdfData || !selectedSection}
              className={classes.iconButtonCustom} // Reutilize a classe ou crie uma nova se precisar de padding diferente
              style={{
                fontSize: "15px",
                marginLeft: "-5px",
                padding: 0, // Para remover padding padrão do Button se for só ícone
                minWidth: "auto", // Para remover minWidth padrão do Button
              }}
            >
              {loadingPdfData ? (
                <ThreeDots
                  color={clientColor || "#000000"}
                  height={15}
                  width={15}
                />
              ) : (
                <FontAwesomeIcon icon={faFilePdf} />
              )}
            </Button>
          </span>
        </Tooltip>
        <EditSectionModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          sections={sections}
          selectedSection={selectedSection}
          onSave={handleSaveSection}
          clientColor={clientColor}
        />
      </div>
    );
  };

  // USE EFFECTS TO LOAD DATA

  // Fetching Sections on component mount
  useEffect(() => {
    const fetchSections = async () => {
      setLoadingSections(true);
      try {
        const response = await client.post("/api/program-meeting/sections/", {
          // Endpoint ajustado para sua URL
          action: "list", // A view ControlPanelSectionsAndDecisionsView espera 'action: list'
        });
        if (response.data && response.data.success) {
          const fetchedSections = response.data.sections || [];
          setSections(fetchedSections);
          if (fetchedSections.length > 0) {
            setSelectedSectionId(fetchedSections[0].id); // Select first section by default
          } else {
            setSelectedSectionId("");
            setSelectedSection(null);
          }
        } else {
          console.error("Failed to fetch sections:", response.data?.error);
          setSections([]);
        }
      } catch (error) {
        console.error("Error fetching sections:", error);
        setSections([]);
      }
      setLoadingSections(false);
    };
    fetchSections();
  }, []); // Empty dependency array means this runs once on mount

  // Update selectedSection when selectedSectionId changes
  useEffect(() => {
    const foundSection = sections.find((s) => s.id === selectedSectionId);
    setSelectedSection(foundSection || null);
  }, [selectedSectionId, sections]);

  // Fetching Sidebar Data (Initiatives) when selectedSectionId changes
  useEffect(() => {
    if (!selectedSectionId) {
      setGroupedInitiatives({});
      setAllBranchesSorted([]);
      setWorkfrontsSortedByBranch({});
      setSelectedInitiative(null);
      return;
    }

    const fetchSidebarData = async () => {
      setLoadingSidebarData(true);
      setSelectedInitiative(null); // Clear previous selection
      setCurrentOnePageData(null); // Clear previous OnePage
      setAvailableOnePageDates([]);
      setSelectedOnePageDate("");

      try {
        const response = await client.post(
          "/api/program-meeting/sidebar-data/",
          {
            section_id: selectedSectionId,
          }
        );
        if (response.data && response.data.success) {
          setGroupedInitiatives(response.data.grouped_initiatives || {});
          setAllBranchesSorted(response.data.all_branches_sorted || []);
          setWorkfrontsSortedByBranch(
            response.data.workfronts_sorted_by_branch || {}
          );

          // Auto-select the first initiative
          const firstBranchName = response.data.all_branches_sorted?.[0];
          if (firstBranchName) {
            const firstWorkfrontName =
              response.data.workfronts_sorted_by_branch?.[firstBranchName]?.[0];
            if (firstWorkfrontName) {
              const firstInitiative =
                response.data.grouped_initiatives?.[firstBranchName]?.[
                  firstWorkfrontName
                ]?.[0];
              if (firstInitiative) {
                setSelectedInitiative(firstInitiative); // This will trigger the OnePage fetch effect
              }
            }
          }
        } else {
          console.error("Failed to fetch sidebar data:", response.data?.error);
          setGroupedInitiatives({});
          setAllBranchesSorted([]);
          setWorkfrontsSortedByBranch({});
        }
      } catch (error) {
        console.error("Error fetching sidebar data:", error);
        setGroupedInitiatives({});
        setAllBranchesSorted([]);
        setWorkfrontsSortedByBranch({});
      }
      setLoadingSidebarData(false);
    };

    fetchSidebarData();
  }, [selectedSectionId]);

  // Fetching OnePage Data (using useCallback for memoization)
  const fetchOnePageDetails = useCallback(
    async (initiative, sectionIdForOP, dateForDropdown) => {
      if (!initiative || !sectionIdForOP) {
        setCurrentOnePageData(null);
        setAvailableOnePageDates([]);
        setSelectedOnePageDate("");
        return;
      }
      setLoadingOnePage(true);
      try {
        const payload = {
          initiative_id: initiative.id,
          section_id: sectionIdForOP, // Use the passed sectionId
        };
        if (dateForDropdown) {
          payload.onepage_date = dateForDropdown;
        }

        const response = await client.post(
          "/api/program-meeting/onepage-data/",
          payload
        );
        if (response.data && response.data.success) {
          setCurrentOnePageData(response.data.onepage_data || null);
          setAvailableOnePageDates(
            response.data.available_dates_in_section || []
          );

          if (dateForDropdown) {
            setSelectedOnePageDate(dateForDropdown);
          } else if (
            response.data.onepage_data &&
            response.data.onepage_data.date
          ) {
            setSelectedOnePageDate(response.data.onepage_data.date);
          } else if (
            response.data.available_dates_in_section &&
            response.data.available_dates_in_section.length > 0
          ) {
            // If no specific OP was returned (e.g. no approved ones), but dates are available, select the first available
            setSelectedOnePageDate(response.data.available_dates_in_section[0]);
            // And try to fetch that specific OP if currentOnePageData is null
            if (!response.data.onepage_data) {
              fetchOnePageDetails(
                initiative,
                sectionIdForOP,
                response.data.available_dates_in_section[0]
              );
            }
          } else {
            setSelectedOnePageDate("");
          }
        } else {
          console.error("Failed to fetch OnePage data:", response.data?.error);
          setCurrentOnePageData(null);
          setAvailableOnePageDates([]);
          setSelectedOnePageDate("");
        }
      } catch (error) {
        console.error("Error fetching OnePage data:", error);
        setCurrentOnePageData(null);
        setAvailableOnePageDates([]);
        setSelectedOnePageDate("");
      }
      setLoadingOnePage(false);
    },
    []
  ); // fetchOnePageDetails is stable now

  // Effect to fetch OnePage when selectedInitiative or selectedSection (its ID for stability) changes
  useEffect(() => {
    if (selectedInitiative && selectedSection) {
      fetchOnePageDetails(selectedInitiative, selectedSection.id, null); // Fetch latest by default for new initiative/section
    } else {
      setCurrentOnePageData(null);
      setAvailableOnePageDates([]);
      setSelectedOnePageDate("");
    }
  }, [selectedInitiative, selectedSection, fetchOnePageDetails]);

  const fetchComments = useCallback(async () => {
    if (
      !selectedInitiative ||
      !selectedSection ||
      !selectedOnePageDate ||
      !currentOnePageData ||
      currentOnePageData.date !== selectedOnePageDate
    ) {
      setComments([]);
      setLoadingComments(false); // Garante que o spinner pare se as condições não forem atendidas
      return;
    }

    setLoadingComments(true);
    try {
      const response = await client.post("/api/program-meeting/comments/", {
        action: "list",
        initiative_id: selectedInitiative.id,
        section_id: selectedSection.id,
        onepage_date: selectedOnePageDate, // Usamos selectedOnePageDate que deve estar alinhado com currentOnePageData.date
      });
      if (response.data && response.data.success) {
        setComments(response.data.comments || []);
      } else {
        console.error("Failed to fetch comments:", response.data?.error);
        setComments([]);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
      setComments([]);
    }
    setLoadingComments(false);
  }, [
    selectedInitiative,
    selectedSection,
    selectedOnePageDate,
    currentOnePageData,
  ]);

  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  // ADICIONE/MODIFIQUE ESTE useEffect:
  useEffect(() => {
    // Condições para a página estar pronta para ser exibida sem o spinner global:
    // 1. As seções devem ter sido carregadas (loadingSections é false E sections tem itens OU não há seções para carregar).
    // 2. Os dados da sidebar devem ter sido carregados (loadingSidebarData é false).
    // 3. Se houver seções, a primeira seção já deve ter sido selecionada (selectedSectionId não é vazio).
    // 4. Os dados da sidebar (allBranchesSorted) devem ter sido populados se houver uma seção selecionada.

    const sectionsLoaded =
      !loadingSections &&
      (sections.length > 0 || (sections.length === 0 && !loadingSections)); // Considera caso de não haver seções
    const sidebarDataLoaded = !loadingSidebarData;

    if (sectionsLoaded && sidebarDataLoaded) {
      if (sections.length > 0) {
        // Se há seções, esperamos que a primeira seja selecionada e a sidebar tenha dados (ou esteja vazia porque não há iniciativas)
        if (
          selectedSectionId &&
          (allBranchesSorted.length > 0 ||
            (Object.keys(groupedInitiatives).length === 0 &&
              !loadingSidebarData))
        ) {
          // O timeout pode ajudar a garantir que o DOM teve tempo de se atualizar com os dados da sidebar
          // antes de remover o spinner global. Isso pode suavizar a transição.
          const timer = setTimeout(() => {
            setIsPageReady(true);
          }, 50); // Pequeno delay, ajuste se necessário ou remova se não ajudar.
          return () => clearTimeout(timer);
        }
      } else {
        // Não há seções, a página pode ser considerada pronta após o loading inicial.
        setIsPageReady(true);
      }
    } else {
      // Se algum dos carregamentos principais estiver ativo, a página não está pronta.
      setIsPageReady(false);
    }
  }, [
    loadingSections,
    loadingSidebarData,
    sections,
    selectedSectionId,
    allBranchesSorted,
    groupedInitiatives,
  ]);

  // HANDLERS

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOnePageDateChange = (event) => {
    const newDate = event.target.value;
    // setSelectedOnePageDate(newDate); // fetchOnePageDetails will set this
    if (selectedInitiative && selectedSection && newDate) {
      fetchOnePageDetails(selectedInitiative, selectedSection.id, newDate);
    }
  };

  const handleReviewToggle = async (checked) => {
    if (!currentOnePageData || !selectedSection) return; // Use currentOnePageData.id
    setTogglingReview(true);
    try {
      const response = await client.post(
        "/api/program-meeting/toggle-review/",
        {
          onepage_id: currentOnePageData.id, // Use ID do OnePage carregado
          // section_id: selectedSection.id, // Backend pode não precisar disso se review_meeting é global no OP
          is_reviewed: checked,
        }
      );
      if (response.data && response.data.success) {
        setCurrentOnePageData((prev) =>
          prev ? { ...prev, reviewed: checked } : null
        );
        // Update sidebar icon if needed
        if (selectedInitiative && groupedInitiatives) {
          const updatedGroupedInitiatives = JSON.parse(
            JSON.stringify(groupedInitiatives)
          );
          let initiativeFound = false;
          for (const branch in updatedGroupedInitiatives) {
            for (const wf in updatedGroupedInitiatives[branch]) {
              const initIndex = updatedGroupedInitiatives[branch][wf].findIndex(
                (i) => i.id === selectedInitiative.id
              );
              if (initIndex > -1) {
                // Check if the reviewed OnePage is the one whose date is stored for the sidebar
                if (
                  currentOnePageData.date ===
                  updatedGroupedInitiatives[branch][wf][initIndex]
                    .latest_onepage_date_in_section
                ) {
                  updatedGroupedInitiatives[branch][wf][
                    initIndex
                  ].is_reviewed_in_section = checked;
                }
                initiativeFound = true;
                break;
              }
            }
            if (initiativeFound) break;
          }
          if (initiativeFound) {
            setGroupedInitiatives(updatedGroupedInitiatives);
          }
        }
      } else {
        console.error("Failed to toggle review:", response.data?.error);
        // Consider reverting checkbox state on error
      }
    } catch (error) {
      console.error("Error toggling review:", error);
    }
    setTogglingReview(false);
  };

  const handleOpenCommentsDrawer = () => setIsCommentsDrawerOpen(true);
  const handleCloseCommentsDrawer = () => setIsCommentsDrawerOpen(false);

  // Add comment

  const handleAddComment = async () => {
    if (
      newComment.trim() === "" ||
      !selectedInitiative ||
      !selectedSection ||
      !selectedOnePageDate
    )
      return;
    setSavingComment(true);
    try {
      const response = await client.post("/api/program-meeting/comments/", {
        action: "create",
        initiative_id: selectedInitiative.id,
        section_id: selectedSection.id,
        onepage_date: selectedOnePageDate, // Date of the OnePage being commented on
        text: newComment,
      });
      if (response.data && response.data.success && response.data.comment) {
        setComments((prevComments) => [...prevComments, response.data.comment]);
        setNewComment("");
      } else {
        console.error("Failed to add comment:", response.data?.error);
        // Potentially show an error to the user
      }
    } catch (error) {
      console.error("Error adding comment:", error);
      // Potentially show an error to the user
    }
    setSavingComment(false);
  };

  const handleSaveSection = async (sectionDataToSave) => {
    const isCreating = !sectionDataToSave.id;
    // A action da view ControlPanelSectionsAndDecisionsView é 'createSection' ou 'updateSection'
    const action = isCreating ? "createSection" : "updateSection";
    const endpoint = "/api/control-panel-sections-decisions/";

    try {
      const response = await client.post(endpoint, {
        action: action,
        ...sectionDataToSave,
      });
      if (response.data && response.data.success) {
        const fetchSectionsAgain = async () => {
          setLoadingSections(true);
          try {
            const res = await client.post(
              "/api/control-panel-sections-decisions/",
              { action: "list" }
            );
            if (res.data && res.data.success) {
              const refreshedSections = res.data.sections || [];
              setSections(refreshedSections);
              if (isCreating && response.data.id) {
                setSelectedSectionId(response.data.id);
              } else if (!isCreating) {
                setSelectedSectionId(sectionDataToSave.id);
              } else if (refreshedSections.length > 0 && !selectedSectionId) {
                setSelectedSectionId(refreshedSections[0].id); // Fallback
              }
            }
          } catch (err) {
            console.error("Error refetching sections:", err);
          }
          setLoadingSections(false);
        };
        fetchSectionsAgain();
        handleCloseModal();
      } else {
        console.error(`Failed to ${action} section:`, response.data?.error);
        alert(
          `Error saving section: ${response.data?.error || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error(`Error ${action} section:`, error);
      alert(`Error saving section: ${error.message || "Network error"}`);
    }
  };

  const toggleBranch = (branch) => {
    setExpandedBranches((prev) =>
      prev.includes(branch)
        ? prev.filter((b) => b !== branch)
        : [...prev, branch]
    );
  };

  const toggleWorkfront = (branch, workfront) => {
    setExpandedWorkfronts((prev) => {
      const branchExpanded = prev[branch] || [];
      return {
        ...prev,
        [branch]: branchExpanded.includes(workfront)
          ? branchExpanded.filter((w) => w !== workfront)
          : [...branchExpanded, workfront],
      };
    });
  };

  // Toggle Side Bar functions

  const handleToggleSidebar = () => {
    const allBranchNames = allBranchesSorted; // Use a lista ordenada de branches
    if (isSidebarExpanded) {
      setExpandedBranches([]);
      setExpandedWorkfronts({});
      setIsSidebarExpanded(false);
    } else {
      setExpandedBranches(allBranchNames);
      const newExpandedWorkfronts = {};
      allBranchNames.forEach((branchName) => {
        // groupedInitiatives[branchName] é um objeto { workfrontName: [initiatives] }
        // workfrontsSortedByBranch[branchName] é uma lista de nomes de workfronts para aquele branch
        newExpandedWorkfronts[branchName] =
          workfrontsSortedByBranch[branchName] || [];
      });
      setExpandedWorkfronts(newExpandedWorkfronts);
      setIsSidebarExpanded(true);
    }
  };

  // Functions to change to next one page

  const getFlatInitiativesInSection = () => {
    const flatList = [];
    if (!allBranchesSorted || !groupedInitiatives || !workfrontsSortedByBranch)
      return [];

    allBranchesSorted.forEach((branchName) => {
      const workfrontNames = workfrontsSortedByBranch[branchName] || [];
      workfrontNames.forEach((workfrontName) => {
        const initiativesList =
          groupedInitiatives[branchName]?.[workfrontName] || [];
        // A iniciativa deve ter 'latest_onepage_date_in_section' para ser navegável
        initiativesList.forEach((initiative) => {
          if (initiative.latest_onepage_date_in_section) {
            flatList.push(initiative);
          }
        });
      });
    });
    // A lista já vem ordenada por status do backend, então não precisa reordenar aqui.
    return flatList;
  };

  const handleNavigate = (direction) => {
    const flatList = getFlatInitiativesInSection();
    if (!flatList.length || !selectedInitiative || !selectedSection) return;

    const currentIndex = flatList.findIndex(
      (initiative) => initiative.id === selectedInitiative.id
    );

    if (currentIndex === -1) {
      // If current is not in the list, just select the first one
      setSelectedInitiative(flatList[0]);
      return;
    }

    let nextIndex;
    if (direction === "next") {
      nextIndex = (currentIndex + 1) % flatList.length;
    } else {
      // 'previous'
      nextIndex = (currentIndex - 1 + flatList.length) % flatList.length;
    }

    const nextInitiative = flatList[nextIndex];

    // Update the selected initiative, which will trigger the useEffect to fetch the OnePage
    setSelectedInitiative(nextInitiative);
  };

  const handleNextOnePage = () => {
    handleNavigate("next");
  };

  const handlePreviousOnePage = () => {
    handleNavigate("previous");
  };

  // FUNCTION TO GENERATE SECTION PDF

  function parseHexColor(hex) {
    // Removes "#" if it exists

    const cleanHex = hex.replace("#", "");
    if (cleanHex.length !== 6) {
      // Fallback

      return { r: 128, g: 128, b: 128 };
    }
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return { r, g, b };
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function lightenColor(hex, amount = 40) {
    const { r, g, b } = parseHexColor(hex);
    return {
      r: clamp(r + amount, 0, 255),
      g: clamp(g + amount, 0, 255),
      b: clamp(b + amount, 0, 255),
    };
  }

  function darkenColor(hex, amount = 40) {
    const { r, g, b } = parseHexColor(hex);
    return {
      r: clamp(r - amount, 0, 255),
      g: clamp(g - amount, 0, 255),
      b: clamp(b - amount, 0, 255),
    };
  }

  const handleGeneratePdf = async () => {
    if (!selectedSection) {
      alert(t("program_meeting.pdf.select_section_first"));
      return;
    }

    setLoadingPdfData(true);

    try {
      const onePagesToIncludeInPdf = [];
      if (allBranchesSorted && groupedInitiatives && workfrontsSortedByBranch) {
        for (const branchName of allBranchesSorted) {
          const workfrontNames = workfrontsSortedByBranch[branchName] || [];
          for (const workfrontName of workfrontNames) {
            const initiativesList =
              groupedInitiatives[branchName]?.[workfrontName] || [];
            for (const initiative of initiativesList) {
              if (
                initiative.is_reviewed_in_section &&
                initiative.latest_onepage_date_in_section
              ) {
                onePagesToIncludeInPdf.push({
                  initiativeId: initiative.id,
                  initiativeName: initiative.name,
                  onePageDate: initiative.latest_onepage_date_in_section,
                });
              }
            }
          }
        }
      }

      if (onePagesToIncludeInPdf.length === 0) {
        alert(t("program_meeting.pdf.no_reviewed_onepages_in_section"));
        setLoadingPdfData(false);
        return;
      }

      let allCommentsForPdf = [];
      for (const opInfo of onePagesToIncludeInPdf) {
        try {
          const response = await client.post("/api/program-meeting/comments/", {
            action: "list",
            initiative_id: opInfo.initiativeId,
            section_id: selectedSection.id,
            onepage_date: opInfo.onePageDate,
          });
          if (
            response.data &&
            response.data.success &&
            response.data.comments.length > 0
          ) {
            const commentsWithContext = response.data.comments.map(
              (comment) => ({
                ...comment,
                initiativeName: opInfo.initiativeName,
              })
            );
            allCommentsForPdf = allCommentsForPdf.concat(commentsWithContext);
          }
        } catch (error) {
          console.error(
            `Error fetching comments for OP ${opInfo.initiativeId} - ${opInfo.onePageDate}:`,
            error
          );
        }
      }

      if (allCommentsForPdf.length === 0) {
        alert(t("program_meeting.pdf.no_comments_found_for_reviewed_ops"));
        setLoadingPdfData(false);
        return;
      }

      const groupedCommentsForPdf = allCommentsForPdf.reduce((acc, comment) => {
        const initId = comment.initiativeId;
        const opDate = comment.onePageDate;

        if (!acc[initId]) {
          acc[initId] = {
            initiativeName: comment.initiativeName,
            onePages: {},
          };
        }
        if (!acc[initId].onePages[opDate]) {
          acc[initId].onePages[opDate] = [];
        }
        acc[initId].onePages[opDate].push(comment);
        return acc;
      }, {});

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "A4",
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const safeClientColor = clientColor || "#000000";
      const headerColorLight = lightenByPercentage(safeClientColor, 0.92);
      const tableHeaderDark = darkenColor(safeClientColor, 10);
      const pdfTitle = `${t("program_meeting.pdf.section_summary_title")} - ${selectedSection.section_name}`;
      const headerHeight = 60; // Define a altura do header como uma constante
      const marginRight = 40; // Define a margem como uma constante

      const drawHeader = () => {
        doc.setFillColor(
          headerColorLight.r,
          headerColorLight.g,
          headerColorLight.b
        );
        doc.rect(0, 0, pageWidth, headerHeight, "F");

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#333333");
        doc.text(pdfTitle, 40, 35);

        // Call the centralized logo function here
        addHeaderLogo({
          docInstance: doc,
          userDetails,
          headerHeight: headerHeight,
          pageWidth: pageWidth,
          pageMarginRight: marginRight,
        });
      };

      const footer = (data) => {
        const totalPages = doc.internal.getNumberOfPages();
        const currentPage = data.pageNumber;
        doc.setFontSize(10);
        doc.setTextColor(120);
        doc.text(
          `${t("program_meeting.pdf.page")} ${currentPage} ${t("program_meeting.pdf.of")} ${totalPages}`,
          pageWidth / 2,
          pageHeight - 15,
          { align: "center" }
        );
      };

      drawHeader();
      let cursorY = 80;

      for (const initiativeId in groupedCommentsForPdf) {
        const initiativeData = groupedCommentsForPdf[initiativeId];
        const sortedOnePageDates = Object.keys(initiativeData.onePages).sort(
          (a, b) => moment(b).diff(moment(a))
        );

        for (const onePageDate of sortedOnePageDates) {
          const commentsList = initiativeData.onePages[onePageDate];
          if (commentsList.length === 0) continue;

          const estimateHeight = 40 + commentsList.length * 20;
          if (
            cursorY + estimateHeight > pageHeight - 40 &&
            Object.keys(groupedCommentsForPdf).indexOf(initiativeId) > 0
          ) {
            doc.addPage();
            drawHeader();
            cursorY = 80;
          } else if (
            Object.keys(groupedCommentsForPdf).indexOf(initiativeId) > 0 ||
            sortedOnePageDates.indexOf(onePageDate) > 0
          ) {
            cursorY += 20;
          }

          doc.setFontSize(14);
          doc.setFont("helvetica", "bolditalic");
          doc.setTextColor(safeClientColor);
          doc.text(
            `• ${initiativeData.initiativeName} (${moment(onePageDate).format("LL")})`,
            40,
            cursorY
          );
          cursorY += 25;

          const rows = commentsList.map((c) => [
            c.author,
            moment(c.timestamp).format("LLL"),
            c.text,
          ]);

          autoTable(doc, {
            startY: cursorY,
            margin: { left: 40, right: 40 },
            head: [
              [
                t("program_meeting.pdf.author"),
                t("program_meeting.pdf.datetime"),
                t("program_meeting.pdf.comment"),
              ],
            ],
            body: rows,
            styles: { fontSize: 10, cellPadding: 4, overflow: "linebreak" },
            headStyles: {
              fillColor: [
                tableHeaderDark.r,
                tableHeaderDark.g,
                tableHeaderDark.b,
              ],
              textColor: [255, 255, 255],
            },
            bodyStyles: {
              fillColor: [245, 245, 245],
              textColor: 50,
              lineColor: [200, 200, 200],
              lineWidth: 0.25,
            },
            alternateRowStyles: { fillColor: [255, 255, 255] },
            didDrawPage: (hookData) => {
              if (hookData.pageNumber > 1 && hookData.cursor.y < 80) {
                drawHeader();
              }
              footer(hookData);
            },
            pageBreak: "auto",
            tableWidth: "auto",
          });
          cursorY = doc.lastAutoTable.finalY;
        }
      }

      const sectionNameForFile = selectedSection.section_name
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "");
      doc.save(`ResumoReuniao_${sectionNameForFile}.pdf`);
    } catch (error) {
      console.error("Error generating PDF data:", error);
      alert(t("program_meeting.pdf.error_generating"));
    } finally {
      setLoadingPdfData(false);
    }
  };

  if (!isPageReady) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 100px)",
          width: "100%",
        }}
      >
        <ThreeDots
          color={clientColor || "#000000"} // Adiciona fallback para clientColor
          height={100}
          width={100}
          ariaLabel="loading-initial-data"
        />
      </div>
    );
  }

  // Render

  return (
    <div className={classes.container}>
      {/* Here we call the floating card */}
      {renderFloatingCard()}
      <GridContainer spacing={2}>
        {/* Sidebar with initiatives */}
        <GridItem xs={12} md={3}>
          <Card style={{ height: "100%" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <FontAwesomeIcon icon={faList} />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {getAltLabel("program_meeting.initiatives.list", userDetails, t)}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "-20px",
                  top: "-5px",
                  zIndex: 1000,
                }}
              >
                <Tooltip
                  title={
                    isSidebarExpanded
                      ? t("program_meeting.filters.collapse_all")
                      : t("program_meeting.filters.expand_all")
                  }
                >
                  <Button
                    justIcon
                    color="client"
                    className={classes.cardButton}
                    onClick={handleToggleSidebar}
                  >
                    {isSidebarExpanded ? (
                      <ExpandLess className={classes.cardButtonIcon} />
                    ) : (
                      <ExpandMore className={classes.cardButtonIcon} />
                    )}
                  </Button>
                </Tooltip>
              </div>
            </CardHeader>
            <PerfectScrollbar style={{ maxHeight: "95vh", width: "100%" }}>
              <CardContent className={classes.sidebarWrapper}>
                <div style={{ padding: "0px 3px 7px 0px" }}>
                  <TextField
                    label={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {getAltLabel("program_meeting.filters.initiatives", userDetails, t)}
                        <Search className={classes.searchIcon} />
                      </div>
                    }
                    size="small"
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{
                      classes: { input: classes.inputText },
                      style: { fontSize: "12px" },
                    }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true,
                    }}
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(e.target.value.toLowerCase())
                    }
                    style={{ width: "100%", marginBottom: "8px" }}
                    placeholder={t(
                      "program_meeting.filters.search_initiatives"
                    )}
                  />
                </div>
                {loadingSidebarData ? (
                  <div className={classes.loadingSpinner}>
                    <ThreeDots
                      color={clientColor}
                      height={40}
                      width={40}
                      ariaLabel="loading-sidebar"
                    />
                  </div>
                ) : (
                  allBranchesSorted.map((branchName) => {
                    const workfrontsMap = groupedInitiatives[branchName] || {};
                    const workfrontNames =
                      workfrontsSortedByBranch[branchName] || [];

                    // Recalcular branchOverallStatus no frontend para UI se necessário (backend já ordena)
                    let branchOverallStatus = "gray";
                    const allBranchInitiativesForUIStatus =
                      workfrontNames.reduce((acc, wfName) => {
                        const inits = workfrontsMap[wfName] || [];
                        return acc.concat(inits);
                      }, []);
                    if (
                      allBranchInitiativesForUIStatus.some(
                        (init) => init.status === "red"
                      )
                    )
                      branchOverallStatus = "red";
                    else if (
                      allBranchInitiativesForUIStatus.some(
                        (init) => init.status === "yellow"
                      )
                    )
                      branchOverallStatus = "yellow";
                    else if (
                      allBranchInitiativesForUIStatus.some(
                        (init) => init.status === "green"
                      )
                    )
                      branchOverallStatus = "green";

                    return (
                      <div key={branchName}>
                        <div
                          className={classes.branchTitle}
                          onClick={() => toggleBranch(branchName)}
                        >
                          <span>{branchName}</span>
                          <span
                            className={classes.statusCircle}
                            style={{
                              backgroundColor:
                                statusToColor(branchOverallStatus),
                              width: 18,
                              height: 18,
                            }}
                          />
                        </div>
                        {expandedBranches.includes(branchName) &&
                          workfrontNames.map((workfrontName) => {
                            const initiativesList = (
                              workfrontsMap[workfrontName] || []
                            ).filter((init) =>
                              init.name.toLowerCase().includes(searchTerm)
                            );
                            if (initiativesList.length === 0 && searchTerm)
                              return null;

                            let wfOverallStatus = "gray"; // Recalcular status do workfront para UI
                            if (
                              initiativesList.some(
                                (init) => init.status === "red"
                              )
                            )
                              wfOverallStatus = "red";
                            else if (
                              initiativesList.some(
                                (init) => init.status === "yellow"
                              )
                            )
                              wfOverallStatus = "yellow";
                            else if (
                              initiativesList.some(
                                (init) => init.status === "green"
                              )
                            )
                              wfOverallStatus = "green";

                            return (
                              <div key={workfrontName}>
                                <div
                                  className={classes.workfrontTitle}
                                  onClick={() =>
                                    toggleWorkfront(branchName, workfrontName)
                                  }
                                >
                                  <span>{workfrontName}</span>
                                  <span
                                    className={classes.statusCircle}
                                    style={{
                                      backgroundColor:
                                        statusToColor(wfOverallStatus),
                                      width: 16,
                                      height: 16,
                                    }}
                                  />
                                </div>
                                {expandedWorkfronts[branchName] &&
                                  expandedWorkfronts[branchName].includes(
                                    workfrontName
                                  ) &&
                                  initiativesList.map(
                                    (
                                      init // initiativesList já está ordenada pelo backend
                                    ) => (
                                      <div
                                        key={init.id}
                                        className={`${classes.initiativeTitle} ${selectedInitiative?.id === init.id ? classes.activeInitiative : ""}`}
                                        onClick={() =>
                                          setSelectedInitiative(init)
                                        } // selectedInitiative agora é o objeto completo
                                      >
                                        <Typography
                                          variant="body2"
                                          style={{ marginRight: 8 }}
                                        >
                                          {init.name}
                                        </Typography>
                                        <div
                                          style={{
                                            marginLeft: "auto",
                                            marginRight: 10,
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            className={classes.statusCircle}
                                            style={{
                                              backgroundColor: statusToColor(
                                                init.status
                                              ),
                                              width: 14,
                                              height: 14,
                                            }}
                                          />
                                          {init.is_reviewed_in_section && ( // usa a prop do backend
                                            <CheckCircle
                                              style={{
                                                color: clientColor,
                                                marginLeft: 6,
                                                fontSize: "18px",
                                              }}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    )
                                  )}
                              </div>
                            );
                          })}
                      </div>
                    );
                  })
                )}
              </CardContent>
            </PerfectScrollbar>
          </Card>
        </GridItem>

        {/* Main Area */}
        <GridItem xs={12} md={9}>
          <Card style={{ height: "100%" }}>
            <CardHeader color="client" icon>
              {/* ... CardIcon e h4 permanecem ... */}
              <CardIcon color="client">
                <FontAwesomeIcon icon={faFile} />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("program_meeting.one_pages")}
              </h4>

              <div
                style={{
                  position: "absolute",
                  right: "80px",
                  top: "0px",
                  transform: "translateX(-50%)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Tooltip title={t("program_meeting.comments.insert")}>
                  <span>
                    {" "}
                    {/* Envolve o botão em um span para o Tooltip funcionar quando desabilitado */}
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleOpenCommentsDrawer}
                      disabled={
                        !selectedInitiative ||
                        !selectedOnePageDate ||
                        loadingComments ||
                        savingComment
                      }
                    >
                      {loadingComments || savingComment ? (
                        <ThreeDots
                          color="white"
                          height={18}
                          width={18}
                          ariaLabel="loading-comment-action"
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faComment}
                          className={classes.cardButtonIcon}
                        />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </div>
              <div
                style={{
                  position: "absolute",
                  right: "40px",
                  top: "0px",
                  zIndex: 1000,
                }}
              >
                <Tooltip title={t("program_meeting.navigation.previous")}>
                  <span>
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handlePreviousOnePage}
                      disabled={!selectedInitiative || loadingOnePage}
                    >
                      {" "}
                      {/* <= ATUALIZADO */}
                      <ArrowBack className={classes.cardButtonIcon} />
                    </Button>
                  </span>
                </Tooltip>
              </div>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "0px",
                  zIndex: 1000,
                }}
              >
                <Tooltip title={t("program_meeting.navigation.next")}>
                  <span>
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleNextOnePage}
                      disabled={!selectedInitiative || loadingOnePage}
                    >
                      {" "}
                      {/* <= ATUALIZADO */}
                      <ArrowForward className={classes.cardButtonIcon} />
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </CardHeader>
            <CardContent className={classes.cardContentWrapper}>
              {selectedInitiative &&
                selectedSection /* Só mostra filtros se uma iniciativa e seção estão selecionadas */ && (
                  <GridContainer spacing={2}>
                    <GridItem xs={12} sm={6} md={4}>
                      <TextField
                        select
                        fullWidth
                        label={t("program_meeting.one_page.select")}
                        value={selectedOnePageDate || ""}
                        onChange={handleOnePageDateChange} // <= ATUALIZADO
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{ classes: { input: classes.inputText } }}
                        InputLabelProps={{
                          classes: { root: classes.labelText },
                          shrink: true,
                        }}
                        disabled={
                          loadingOnePage || availableOnePageDates.length === 0
                        } // <= ATUALIZADO
                      >
                        {availableOnePageDates.map(
                          (
                            dateIso // Usa availableOnePageDates
                          ) => (
                            <MenuItem
                              key={dateIso}
                              value={dateIso} // O valor é a string ISO da data
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                            >
                              {moment(dateIso).format("LL")}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      {selectedOnePageDate &&
                        currentOnePageData && ( // Só mostra se tiver um OnePage carregado
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={currentOnePageData.reviewed || false} // Usa currentOnePageData
                                onChange={(e) =>
                                  handleReviewToggle(e.target.checked)
                                }
                                icon={
                                  <RadioButtonUnchecked
                                    style={{ color: "#aaa" }}
                                  />
                                }
                                checkedIcon={
                                  <CheckCircle style={{ color: clientColor }} />
                                }
                                disabled={
                                  togglingReview ||
                                  loadingOnePage ||
                                  !currentOnePageData
                                } // <= ATUALIZADO
                              />
                            }
                            label={t("program_meeting.one_page.reviewed")}
                            className={classes.reviewCheckbox}
                          />
                        )}
                    </GridItem>
                  </GridContainer>
                )}

              {loadingOnePage ? (
                <div
                  className={classes.loadingSpinner}
                  style={{ minHeight: "300px" }}
                >
                  {" "}
                  {/* Adiciona minHeight para dar espaço ao spinner */}
                  <ThreeDots
                    color={clientColor}
                    height={80} // Spinner maior para a área principal
                    width={80}
                    ariaLabel="loading-onepage"
                  />
                </div>
              ) : currentOnePageData ? (
                <OnePage
                  selectedInitiative={selectedInitiative} // Passa a iniciativa selecionada
                  onePageInfoData={[currentOnePageData]} // onePageInfoData agora é um array com o OnePage atual
                  defaultOnePageDate={currentOnePageData.date} // Data do OnePage atual
                  onePageHasApproval={onePageHasApprovalConfig} // Configuração de aprovação
                  setOnePageInfoData={() => {}} // Stub, pois o estado é gerenciado aqui
                  fetchOnePageData={() => {}} // Stub
                  t={t}
                  classes={classes}
                  showContent={false} // ou false, dependendo da necessidade de edição interna do OnePage
                />
              ) : selectedInitiative ? ( // Se uma iniciativa está selecionada mas não há OnePage
                <Typography>
                  {t("program_meeting.one_page.no_data_for_selection")}
                </Typography>
              ) : (
                // Se nenhuma iniciativa está selecionada
                <Typography>
                  {getAltLabel("program_meeting.one_page.select_initiative", userDetails, t)}
                </Typography>
              )}
            </CardContent>
          </Card>
        </GridItem>
      </GridContainer>
      {/* Drawer for comments input*/}
      <Drawer
        anchor="bottom"
        open={isCommentsDrawerOpen}
        onClose={handleCloseCommentsDrawer}
        PaperProps={{
          style: {
            height: "35vh",
            borderRadius: "7px",
            padding: "3px 10px 10px 10px",
            margin: "0vh 1vh 1vh 1vh",
            // Remove or maintain overflow as needed
            // overflow: "hidden",

            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <PerfectScrollbar style={{ maxHeight: "100%", width: "100%" }}>
          <GridItem
            style={{
              zIndex: 1000,
              position: "absolute",
              right: "20px",
              top: "20px",
              color: "#3C4858",
            }}
          >
            <Tooltip title={t("program_meeting.comments.save")}>
              <span>
                <Button
                  justIcon
                  color="client"
                  className={classes.cardButton}
                  onClick={handleAddComment} // handleAddComment já está correto
                  disabled={savingComment || newComment.trim() === ""}
                >
                  {savingComment ? (
                    <ThreeDots // <= AQUI
                      color="white"
                      height={18}
                      width={18}
                      ariaLabel="saving-comment"
                    />
                  ) : (
                    <SaveIcon className={classes.cardButtonIcon} />
                  )}
                </Button>
              </span>
            </Tooltip>
          </GridItem>
          <div
            style={{
              flex: 1,
              padding: "8px",
              fontSize: "0.9rem",
              transformOrigin: "top center",
            }}
            className={classes.drawerContent}
          >
            <GridContainer style={{ marginTop: "10px" }}>
              <GridItem xs={12} md={12}>
                <Typography
                  variant="body1"
                  style={{
                    color: "#555",
                    fontWeight: 500,
                    marginBottom: "10px",
                  }}
                >
                  {`${t("program_meeting.comments.title_for")} ${selectedInitiative?.name || getAltLabel("program_meeting.comments.no_initiative_selected", userDetails, t)} - ${selectedSection?.section_name || ""} (${selectedOnePageDate ? moment(selectedOnePageDate).format("LL") : t("program_meeting.comments.no_date_selected")})`}
                </Typography>
                {loadingComments ? (
                  <div
                    className={classes.loadingSpinner}
                    style={{ minHeight: "100px" }}
                  >
                    {" "}
                    <ThreeDots
                      color={clientColor}
                      height={40}
                      width={40}
                      ariaLabel="loading-comments-list"
                    />
                  </div>
                ) : (
                  <List>
                    {comments.map(
                      (
                        comment //
                      ) => (
                        <React.Fragment key={comment.id}>
                          <ListItem alignItems="flex-start">
                            <ListItemText
                              primary={`${comment.author} - ${moment(comment.timestamp).format("LLL")}`}
                              secondary={comment.text}
                            />
                          </ListItem>
                          <Divider component="li" />
                        </React.Fragment>
                      )
                    )}
                  </List>
                )}
              </GridItem>
              <GridItem xs={12} md={12} style={{ marginTop: "20px" }}>
                <TextField
                  label={t("program_meeting.comments.add")}
                  multiline
                  rows={2}
                  variant="outlined"
                  fullWidth
                  placeholder={t("program_meeting.comments.placeholder")}
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                  helperText={`${newComment.length}/500`} // Limite aumentado
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{
                    classes: {
                      input: classes.inputText,
                      root: classes.outlinedInput,
                    },
                    style: { fontSize: "12px" },
                    inputProps: { maxLength: 500 }, // Limite aumentado
                  }}
                  InputLabelProps={{
                    classes: { root: classes.labelText },
                    shrink: true,
                    style: {
                      backgroundColor: "#fff",
                      zIndex: 150,
                      padding: "0px 10px",
                      fontWeight: "700",
                      textTransform: "uppercase",
                    },
                  }}
                  disabled={
                    !selectedInitiative || !selectedOnePageDate || savingComment
                  } // <= ATUALIZADO
                />
              </GridItem>
            </GridContainer>
          </div>
        </PerfectScrollbar>
      </Drawer>
    </div>
  );
}
